import { Box, Typography } from "@mui/material";
import { BadgeBox } from "./BadgeBox";

export const LegendItem = ({ shortLabel, fullLabel, title, description }) => (
  <Box sx={{ py: 1.5, px: 2 }}>
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        mb: 1,
      }}
    >
      {/* Badge */}
      <BadgeBox shortLabel={shortLabel} fullLabel={fullLabel} />
      {/* Title and Description */}
      <Box sx={{ flex: 1 }}>
        <Typography
          variant="subtitle2"
          fontWeight={600}
          sx={{
            color: "#1e293b",
            mb: 0.25,
            fontSize: 14,
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: "#64748b",
            fontSize: 12,
            lineHeight: 1.4,
          }}
        >
          {description}
        </Typography>
      </Box>
    </Box>
  </Box>
);
